import gql from 'graphql-tag';

const GET_USERS_BY_FILTER = gql`
    query getUsersByFilter (
        $fields: [String],
        $dateRange: RangeInput,
        $filters: [FilterInput],
        $size: Int,
        $page: Int,
        $sort: String
    ) {
        getUsersByFilter (
            fields: $fields,
            dateRange: $dateRange,
            filters: $filters,
            size: $size,
            page: $page,
            sort: $sort
            ) {
                totalRecords
                status
                message
                data {
                    shortName
                    email
                    salesChannelInfo {
                        salesChannelId
                        action
                        isActive
                    }
                    company
                    connections {
                        count
                    }
                    status
                    statusLabel
                    lastConnection
                    salesChannelActive
                    statistics {
                        foundrate
                        fillrate
                        ordersCompleted
                        contactEffectiveness
                    }
                }
        }
    }
`;

export default GET_USERS_BY_FILTER;
